import { Table, TableBody, TableCell, TableHead, TableRow, IconButton, Avatar, TableSortLabel } from "@mui/material"
import { Edit, Trash2 } from "lucide-mui"
import React from "react"

import { UserSortField, SortDirection } from "@/graphql/graphql"
import i18n from "@/i18n"

interface UsersTableProps {
  users: any[]
  sortBy: UserSortField
  sortDirection: SortDirection
  onSort: (field: UserSortField) => void
  onEdit: (user: any) => void
  onDelete: (user: any) => void
}

const UsersTable: React.FC<UsersTableProps> = ({ users, sortBy, sortDirection, onSort, onEdit, onDelete }) => {
  return (
    <div className="bg-white rounded-lg shadow" data-testid="settings-users-table-container">
      <Table data-testid="settings-users-table">
        <TableHead>
          <TableRow>
            <TableCell>
              <TableSortLabel
                active={sortBy === UserSortField.Name}
                direction={sortBy === UserSortField.Name ? (sortDirection.toLowerCase() as "asc" | "desc") : "asc"}
                onClick={() => onSort(UserSortField.Name)}
                data-testid="settings-users-table-sort-name"
              >
                {i18n.t("app.settings.users.list.table.user")}
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={sortBy === UserSortField.Email}
                direction={sortBy === UserSortField.Email ? (sortDirection.toLowerCase() as "asc" | "desc") : "asc"}
                onClick={() => onSort(UserSortField.Email)}
                data-testid="settings-users-table-sort-email"
              >
                {i18n.t("app.settings.users.list.table.email")}
              </TableSortLabel>
            </TableCell>
            <TableCell>{i18n.t("app.settings.users.list.table.role")}</TableCell>
            <TableCell align="right">{i18n.t("app.settings.users.list.table.actions")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((user) => {
            const uniqueRoles = Array.from(new Set(user.roles?.map((r: any) => r.role).filter(Boolean) || []))
            const rolesDisplay = uniqueRoles.map(String).join(", ") || "-"

            return (
              <TableRow key={user.id} data-testid={`settings-users-table-row-${user.id}`}>
                <TableCell>
                  <div className="flex items-center gap-3">
                    <Avatar src={user.avatarUrl || undefined}>
                      {user.firstName?.[0]}
                      {user.lastName?.[0]}
                    </Avatar>
                    <span className="font-medium">{user.name}</span>
                  </div>
                </TableCell>
                <TableCell>{user.email}</TableCell>
                <TableCell>{rolesDisplay}</TableCell>
                <TableCell align="right">
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => onEdit(user)}
                    data-testid={`settings-users-table-btn-edit-${user.id}`}
                  >
                    <Edit className="w-4 h-4" />
                  </IconButton>
                  <IconButton
                    size="small"
                    color="error"
                    onClick={() => onDelete(user)}
                    data-testid={`settings-users-table-btn-delete-${user.id}`}
                  >
                    <Trash2 className="w-4 h-4" />
                  </IconButton>
                </TableCell>
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </div>
  )
}

export default UsersTable
